import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  Pagination,
  Navigation,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "../styles/hero.css";

export default function HeroSlider() {
  return (
    <section
      className="hero-slider"
      aria-label="VK Bike On Rent services in Udaipur"
    >
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        autoplay={{
          delay: 5500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        loop={true}
      >
        {/* =====================================================
            SLIDE 1 — PRIMARY HOMEPAGE TOPIC
        ====================================================== */}

        <SwiperSlide>
          <div
            className="slide slide-bike"
            role="group"
            aria-label="Bike and scooty rental in Udaipur"
          >
            <div className="slide-content">

              <h1>
                Bike & Scooty Rental in Udaipur
              </h1>

              <p>
                Rent bikes and scooters in Udaipur and explore
                City Palace, Lake Pichola, Jagdish Temple and
                the city's historic streets at your own pace.
              </p>

              <Link
                to="/bikes"
                className="hero-btn"
                aria-label="View bikes and scooters available for rent in Udaipur"
              >
                View Available Bikes
              </Link>

            </div>
          </div>
        </SwiperSlide>

        {/* =====================================================
            SLIDE 2 — TAXI SERVICE
        ====================================================== */}

        <SwiperSlide>
          <div
            className="slide slide-taxi"
            role="group"
            aria-label="Taxi and cab services in Udaipur"
          >
            <div className="slide-content">

              <h2>
                Taxi & Cab Services in Udaipur
              </h2>

              <p>
                Travel around Udaipur with taxi options for
                local sightseeing, airport pickup and drop,
                and other travel requirements.
              </p>

              <Link
                to="/taxi"
                className="hero-btn"
                aria-label="View taxi and cab services in Udaipur"
              >
                View Taxi Services
              </Link>

            </div>
          </div>
        </SwiperSlide>

        {/* =====================================================
            SLIDE 3 — EXPERIENCE / BRAND
        ====================================================== */}

        <SwiperSlide>
          <div
            className="slide slide-why"
            role="group"
            aria-label="Explore Udaipur with VK Bike On Rent"
          >
            <div className="slide-content">

              <h2>
                Explore Udaipur Your Way
              </h2>

              <p>
                From early morning rides to sunset views around
                the lakes, choose a convenient way to explore
                Udaipur.
              </p>

              <Link
                to="/contact"
                className="hero-btn"
                aria-label="Contact VK Bike On Rent in Udaipur"
              >
                Contact Us
              </Link>

            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
}